<!-- 表口径列表 -->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('任务名称')">
              <a-input :placeholder="$t('请输入任务名称')" v-model="queryParam.fotaTaskName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('表号')">
              <a-input :placeholder="$t('请输入升级表号')" v-model="queryParam.meterId"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('升级状态')">
              <j-dict-select-tag v-model="queryParam.meterFotaState" :placeholder="$t('请选择升级状态')" dictCode="fota_state"/>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div style="text-align: right">
      <a-button @click="remoteBatch" style="background-color: #87CEFA">{{ $t('fota批量升级') }}</a-button>
    </div>
    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange"
        >
        <label slot="meterFotaState" slot-scope="text, record" :class="[record.meterFotaState === 1||record.meterFotaState === 0?'doing-status': record.meterFotaState === 3?'finish-status':'fail-status']">
          {{$t(meterFotaStateObj[record.meterFotaState])}}
        </label>
        <span slot="action" slot-scope="text, record">
            <a @click="handleFotaCommand(record)">{{ $t('FOTA命令查询') }}</a>
          <a-divider type="vertical" />
          <a @click="handleDetail(record)">{{ $t('详情') }}</a>

          <a-popconfirm :title="$t('确定取消升级吗?')" @confirm="() => handleCancel(record.id)">
            <span v-if="record.meterFotaState===1||record.meterFotaState===0">
              <a-divider type="vertical" />
              <a >{{ $t('取消') }}</a>
            </span>
        </a-popconfirm>
        </span>
      </a-table>
    </div>
    <remote-up-batch-modal ref="modalForm" @ok="modalFormOk"></remote-up-batch-modal>
    <meter-fota-command-modal ref="meterFotaCommandModal" @ok="modalFormOk"></meter-fota-command-modal>
    <meter-fota-detail-modal ref="meterFotaDetailModal" @ok="modalFormOk"></meter-fota-detail-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import {isUndefined} from'@/utils/validate'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { putAction } from '../../api/manage'
  import remoteUpBatchModal from './modules/remoteUpBatchModal'
  import meterFotaCommandModal from './modules/meterFotaCommandModal'
  import meterFotaDetailModal from './modules/meterFotaDetailModal'

  export default {
    name: 'MeterCaliberList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      remoteUpBatchModal,
      meterFotaCommandModal,
      meterFotaDetailModal
    },
    data () {
      const  meterFotaStateObj= {0: '待升级',1: '升级中',3: '升级成功',4: '升级失败','-1': '取消升级'};
      return {
        description: 'fota升级队列管理页面',
        meterFotaStateObj,
        url: {
          list: "/jeecg-charge/meter/meterFotaDetail/list",
          delete: "/jeecg-charge/meter/meterFotaDetail/delete",
          deleteBatch: "/jeecg-charge/meter/meterFotaDetail/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/meterFotaDetail/exportXls",
          importExcelUrl: "jeecg-charge/meter/meterFotaDetail/importExcel",
          edit: "jeecg-charge/meter/meterFotaDetail/edit"
        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:(t,r,index) => {
              return parseInt(index)+1;
            }
          },{
            title: this.$t('表号'),
            align:"center",
            dataIndex: 'meterId'
          },{
            title: this.$t('升级方案名称'),
            align:"center",
            dataIndex: 'fotaTaskName'
          },{
            title: this.$t('升级状态'),
            align:"center",
            dataIndex: 'meterFotaState',
            scopedSlots: { customRender: 'meterFotaState' },
          },{
            title: this.$t('新固件版本号'),
            align:"center",
            dataIndex: 'softwareNewVersion'
          },{
            title: this.$t('老固件版本号'),
            align:"center",
            dataIndex: 'softwareOldVersion'
          },{
            title: this.$t('创建时间'),
            align:"center",
            dataIndex: 'createTime'
          },{
            title: this.$t('创建人'),
            align:"center",
            dataIndex: 'createBy'
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      handleCancel(id){
          // 取消升级
          putAction(this.url.edit,{id: id,meterFotaState: -1}).then((res)=> {
              if(res.success) {
                  this.$message.success(this.$t("取消升级成功"))
                  this.loadData(true)
              }else{
                  this.$message.error(res.message)
              }
          })
      },
      handleFotaCommand(record) {
          // 查看升级过程中的命令
        this.$refs.meterFotaCommandModal.edit(record)
      },
      remoteBatch() {
        this.$refs.modalForm.add()
      },
      handleDetail:function(record){
        this.$refs.meterFotaDetailModal.edit(record);
        this.$refs.meterFotaDetailModal.title=this.$t("详情");
        this.$refs.meterFotaDetailModal.disableSubmit = true;
        },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>